import { local } from './local';
export * from './constants';

export const log = {
    local,
};
